var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ fullscreen: _vm.getIsFullscreen },attrs:{"id":"root"}},[(_vm.hasHeader)?_c('the-header'):_vm._e(),_c('the-sidebar'),_c('router-view',{staticClass:"view"}),_c('the-cookie-banner'),(_vm.hasFooter)?_c('the-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }